import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHelmet = ({
  title = 'Safarnamah',
  description = 'Discover personalized travel experiences with Safarnamah. Expert travel guides, hotel recommendations, and tailored trip planning for Southeast Asian destinations.',
  keywords = 'Safarnamah, Saket, saketbundele, safarnama, saket bundele safarnama, saket bundele, Saket bundele safarnamah, safrnam, pallavi korade, travel guide, trip planning, Southeast Asia',
  image = 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=1200&h=630&fit=crop',
  url = 'https://safarnamah.in',
  type = 'website',
  author = 'Saket Bundele, Pallavi Korade',
  canonicalUrl = null
}) => {
  const fullTitle = title === 'Safarnamah' ? title : `${title} | Safarnamah`;
  const finalUrl = canonicalUrl || url;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      
      {/* Robots and Crawling */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={finalUrl} />
      
      {/* Open Graph Tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:site_name" content="Safarnamah" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional SEO Meta Tags */}
      <meta name="revisit-after" content="7 days" />
      <meta name="rating" content="general" />
      <meta name="theme-color" content="#FAF8F5" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
    </Helmet>
  );
};

export default SEOHelmet;
